module.exports = __webpack_public_path__ + "static/media/kutch.2305a5e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/kutch.jpg
// module id = 1004
// module chunks = 0